import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';

@Component({
  selector: 'app-course-meta',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './course-meta.component.html',
  styleUrl: './course-meta.component.scss',
})
export class CourseMetaComponent {
  course = input<ChallengeGen.Course | null>(null);

  metaCards = computed(() => [
    {
      icon: 'globe',
      labelKey: 'app.components.courseMeta.language.en',
    },
  ]);
}
